import { useContext, useEffect } from "react";
import { ProductContext } from "../../Contexts/ProductContext";
import { UserProfile } from "../../Component/UserProfile/UserProfile";
import { UserAddress } from "../../Component/UserAddress/UserAddress";
import "./UserDetailsStyle.css";
import OrderHistory from "../OrderHistory/OrderHistory";
import { isEmpty, printDebugLog } from "../../Utils/utils";
import { AuthContext } from "../../Contexts/AuthContext";

const UserDetails = () => {
  const { isProfileTab, setIsProfileTab, getOrderHistory, 
      generateBillPdf,initiatePaymentAgain, productState } = useContext(ProductContext);
  const { authState } = useContext(AuthContext);
  useEffect(() => {
    window.scrollTo(0, 0);
    getOrderHistory();
  }, []);

  useEffect(() => {
    printDebugLog("Orders in userdetails", productState?.orders)
  }, [productState?.orders])



  return (
    <div className="user-details-page">
      <h1 className="user-details-heading">User Details</h1>
      <div className="user-details-container">
        <div className="user-details-tab-container">
          <div className="user-details-tab">
            <input
              type="radio"
              name="tabs"
              id="profile"
              checked={isProfileTab}
              onChange={() => setIsProfileTab(!isProfileTab)}
            />
            <label htmlFor="profile">Profile</label>
          </div>
          <div className="user-details-tab">
            <input
              type="radio"
              name="tabs"
              id="address"
              checked={!isProfileTab}
              onChange={() => setIsProfileTab(!isProfileTab)}
            />
            <label htmlFor="address">Address</label>
          </div>
        </div>

        {isProfileTab ? <UserProfile /> : <UserAddress />}
      </div>
      {
        !isEmpty(authState?.mobile) &&
        <h1 className="user-details-heading">Order History</h1>
      }

      {
        !isEmpty(authState?.mobile) &&
        <OrderHistory
          orders={productState?.orders}
          onActionClick={(bilNo) => generateBillPdf(bilNo)}
          onInitiatePaymentAgain={(bilNo) => initiatePaymentAgain(bilNo)}
        />
      }
    </div>
  );
};
export { UserDetails };
